export type LegacyScheduleBatchOffice = { id: string; name: string }
export type LegacyScheduleBatchWorker = { id: string; name: string }
export type LegacyScheduleBatchColor = { id: string; name: string; value: string }

export const legacyScheduleBatchOfficeOptions: LegacyScheduleBatchOffice[] = [
  { id: 'mock-office-01', name: 'Mock 지점 A' },
  { id: 'mock-office-02', name: 'Mock 지점 B' },
]

export const legacyScheduleBatchWorkerOptions: LegacyScheduleBatchWorker[] = [
  { id: 'mock-worker-01', name: 'Mock 작업담당 A' },
  { id: 'mock-worker-02', name: 'Mock 작업담당 B' },
]

export const legacyScheduleBatchColorOptions: LegacyScheduleBatchColor[] = [
  { id: 'mock-color-01', name: 'Mock 분홍', value: '#ff6c86' },
  { id: 'mock-color-02', name: 'Mock 주황', value: '#ff9a5e' },
  { id: 'mock-color-03', name: 'Mock 노랑', value: '#f6d85d' },
  { id: 'mock-color-04', name: 'Mock 초록', value: '#8ed7a5' },
  { id: 'mock-color-05', name: 'Mock 하늘', value: '#66c0e8' },
  { id: 'mock-color-06', name: 'Mock 파랑', value: '#8598e9' },
  { id: 'mock-color-07', name: 'Mock 보라', value: '#c488d7' },
]

// 기존 S-05/S-06 화면이 사용하는 이름 배열은 계속 제공한다.
export const legacyScheduleBatchOffices = legacyScheduleBatchOfficeOptions.map((office) => office.name)
export const legacyScheduleBatchWorkers = legacyScheduleBatchWorkerOptions.map((worker) => worker.name)
export const legacyScheduleBatchColors = legacyScheduleBatchColorOptions.map((color) => color.value)

export type LegacyScheduleBatchHistory = {
  id: string
  office: string
  registeredAt: string
  title: string
  startDate: string
  endDate: string
  staff: string
  scheduleCount: number
  isOwn: boolean
  schedules: { date: string; time: string; worker: string }[]
}

export const legacyScheduleBatchHistory: LegacyScheduleBatchHistory[] = [
  { id: 'mock-batch-01', office: 'Mock 지점 A', registeredAt: '2026-08-20 09:00', title: 'Mock 정기 일정', startDate: '2026-08-01', endDate: '2026-08-31', staff: 'Mock 작업자 A', scheduleCount: 2, isOwn: true, schedules: [{ date: '2026-08-03', time: '09:00 ~ 10:00', worker: 'Mock 작업담당 A' }, { date: '2026-08-10', time: '09:00 ~ 10:00', worker: 'Mock 작업담당 A' }] },
  { id: 'mock-batch-02', office: 'Mock 지점 A', registeredAt: '2026-08-19 14:30', title: 'Mock 안내 일정', startDate: '2026-08-19', endDate: '2026-08-26', staff: 'Mock 작업자 B', scheduleCount: 1, isOwn: false, schedules: [{ date: '2026-08-19', time: '14:00 ~ 15:00', worker: '-' }] },
]

export type LegacyScheduleMemoPreset = { id: string; officeId: string; name: string; content: string; visible: boolean }

export const legacyScheduleMemoPresets: LegacyScheduleMemoPreset[] = [
  { id: 'mock-preset-01', officeId: 'mock-office-01', name: 'Mock 첫 안내', content: '비식별 Mock 고객 내용 안내입니다.', visible: true },
  { id: 'mock-preset-02', officeId: 'mock-office-01', name: 'Mock 예약 확인', content: '비식별 Mock 예약 확인 내용입니다.', visible: true },
  { id: 'mock-preset-03', officeId: 'mock-office-01', name: 'Mock 준비 안내', content: '비식별 Mock 준비 사항입니다.', visible: true },
  { id: 'mock-preset-04', officeId: 'mock-office-01', name: 'Mock 일정 안내', content: '비식별 Mock 일정 내용입니다.', visible: true },
  { id: 'mock-preset-05', officeId: 'mock-office-01', name: 'Mock 후속 안내', content: '비식별 Mock 후속 안내입니다.', visible: true },
  { id: 'mock-preset-06', officeId: 'mock-office-01', name: 'Mock 확인 요청', content: '비식별 Mock 확인 요청입니다.', visible: true },
  { id: 'mock-preset-07', officeId: 'mock-office-01', name: 'Mock 마무리', content: '비식별 Mock 마무리 안내입니다.', visible: true },
  { id: 'mock-preset-08', officeId: 'mock-office-02', name: 'Mock 지점 B 안내', content: '비식별 Mock 지점 B 안내입니다.', visible: true },
  { id: 'mock-preset-09', officeId: 'mock-office-02', name: 'Mock 지점 B 숨김', content: '비식별 Mock 지점 B 숨김 안내입니다.', visible: false },
]
